// @flow

export const UserTypeEnum = Object.freeze({
  Personnel: 'PERSONNEL',
  Rider: 'RIDER',
});

export type UserTypeEnumType = $Values<typeof UserTypeEnum>;
